var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddDueDateWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6FE",
    d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E0AF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M33 22H15m13-8v4m-8-4v4m-.2 16h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C33 31.72 33 30.88 33 29.2v-8.4c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C30.72 16 29.88 16 28.2 16h-8.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C15 18.28 15 19.12 15 20.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C17.28 34 18.12 34 19.8 34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDueDateWithBg);
export default __webpack_public_path__ + "static/media/add-due-date-with-bg.50947c67e99675d6d836b7d7cd13b6fd.svg";
export { ForwardRef as ReactComponent };